import CardIcon, { ICardIconColor } from 'components/Card/CardIcon';
import LocationCity from '@material-ui/icons/LocationCity';
import { BodyS } from 'components/Typography/Typography';
import React from 'react';

interface IIconProps {
	text: string;
	color: ICardIconColor;
}

const Icon = ({ text, color }: IIconProps) => {
	return (
		<div>
			<CardIcon color={color} size="sm">
				<LocationCity />
			</CardIcon>
			<BodyS color="primary-light">{text}</BodyS>
		</div>
	);
};

export default Icon;
